import { IUsersData } from 'types/users';
import api from '../services/config/api';

export const getUserData = (id: string) => api.get<IUsersData>(`/user/${id}`);
